<template>
    <div class="catalogue">
        <div class="header-tool">
            <div class="header-tool-info">
                <Breadcrumb>
                    <BreadcrumbItem>首页</BreadcrumbItem>
                    <BreadcrumbItem>展位楣板信息登记表</BreadcrumbItem>
                </Breadcrumb>
                <div class="header-tool-title">展位楣板信息登记表</div>
            </div>
            <div class="header-tool-box">
                <div class="htb-item" @click="goOne">
                    <span>返回首页</span>
                </div>
            </div>
        </div>
        <div class="marginCss20">
            <p class="fontWig">截止日期：{{ endDate }}</p>
            <!-- <p class="fontWig marginTop20">《广州国际分析测试及实验室设备展览会暨技术研讨会会刊》是大会组委会唯一指定的参展商、参观商会刊资料。</p> -->
            <div class="paddingCss20 backBlue marginTop20">
                <p  v-html="instructions"></p>
            </div>
        </div>

        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" size="small" label-width="100px" class="demo-ruleForm" style="width:79%;margin-left: 50px;">
            <el-form-item label="公司名称" prop="name">
                <div style="display: flex;" >
                    <p > <el-input v-model="ruleForm.name" placeholder="请输入公司名称"  style="width:500px;"></el-input></p>
                </div>
            </el-form-item>
            <el-form-item label="英文名称" prop="nameEn">
                <div style="display: flex;">
                    <p style=""> <el-input v-model="ruleForm.nameEn" style="width:500px;" placeholder="请输入英文名称"></el-input></p>
                </div>
            </el-form-item>
        </el-form>

        <div class="marginCss20">
            <div class="paddingCss20 backBlue marginTop20">
                <span v-html="contactIllustrate"></span>
            </div>
        </div>
        <div class="flexCenter div_btu">
            <el-button type="primary" @click="submitForm('ruleForm')" >保存并提交</el-button>
            <el-button @click="goOne">取消</el-button>

        </div>


        <!-- 选择文件上传方式 -->
        <!-- <imgUpload @upload:local="uploadLocal" @upload:material="uploadMaterial" :maxCount="1" v-model="uploadChooseShowed" /> -->
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import imgUpload from "@components/imgUpload/imgUpload.vue";
import { validator } from "@/other/validator";
import config from "@assets/config.json";

export default {
    name: "exhibition-info-catalogue",
    data () {

        return {
            catalogueInfoIsHave: false, // 会刊信息是否存在

            ruleForm: {
                name: '',
                nameEn:''
            },
            rules: {
                name: [
                    { required: true, message: '请输入公司名称', trigger: 'blur' },
                ],
                nameEn: [
                    { required: true, message: '请输入英文名称', trigger: 'blur' },
                ],
            },
            loading: false,
            endDate: null,
            instructions: null,
            contactIllustrate: null,
            IsSubmitDeadlineToo:false
        };
    },
    components: {
        // imgUpload,
    },
    computed: {
        ...mapGetters({
            exhibitor: "loginModule/getExhibitor",
         
        }),
        exhibitionId () {
            return this.exhibition.id;
        },
    },
    created () {
         
        this.init();
    },
    methods: {
        ...mapActions({
            setManageSettingQ: 'hostSetModule/setManageSettingQ', //
            updatLintelrecord: 'exhibitionModule/updatLintelrecord', //展位楣板信息登记表 修改
            getlintelrecord: 'exhibitionModule/getlintelrecord', //  获取展位楣板信息登记表
        }),
        goOne () {
            this.$router.push(`/exhibition/index/home`);

        },


        async init () {
            let opt = {
                providerName: "Global",
                names: ['Lintel.SubmitDeadline',  'Lintel.FormDescription', 'Lintel.ContractDescription','Lintel.IsSubmitDeadlineToo']
            }
            let res = await this.setManageSettingQ(opt)
            if (res) {
                console.log(res, 'res');
                if (res[0].value) {

                    console.log(this.endDate, 'res');
                    let dateStr = res[0].value;
                    let date = new Date(dateStr);
                    let year = date.getFullYear();
                    let month = date.getMonth() + 1;
                    let day = date.getDate();
                    let formattedDate = year + "年" + (month < 10 ? "0" + month : month) + "月" + (day < 10 ? "0" + day : day) + "日";
                    console.log(formattedDate); // "2023年05月19日"
                    // this.endDate = formattedDate
                    this.endDate = res[0].value

                }
                if (res[1].value) {
                    this.instructions = res[1].value
                }
                if (res[2].value) {
                    this.contactIllustrate = res[2].value
                }
                this.IsSubmitDeadlineToo = res[3].value
            } 
  
            await this.getList()
        },
        async getList(){
            let res = await this.getlintelrecord(this.exhibitor.id)
            if(res){
                this.ruleForm.name=res.name
                this.ruleForm.nameEn=res.nameEn
    
            }
        },
        async submitForm (name) {
            let bool = this.regular.contrastDate(this.regular.compareDate(), this.endDate)
            // 为true 截止日期到了 不能提交
            if (bool) {
                console.log(bool);
                console.log(this.IsSubmitDeadlineToo,typeof(this.IsSubmitDeadlineToo));
                if (this.IsSubmitDeadlineToo=='false') {
                    this.$message.warning("超过截止日期不能提交");
                    return
                }
            }

            let valid = await this.validForm(name);
            if (!valid) return
            console.log(this.exhibitor.id);
            const opt = {
                id: this.exhibitor.id,
                body: {
                    name: this.ruleForm.name,
                    nameEn: this.ruleForm.nameEn,
          
                }
            }
            let res = await this.updatLintelrecord(opt)
            if (res) {
                this.$Message.success("操作成功");
                this.getList();
            } else {
                this.$Message.error("操作失败");
            }

        },

        validForm (name) {
            // 验证表单
            return new Promise((resolve, reject) => {
                this.$refs[name].validate((valid) => {
                    resolve(valid);
                });
            });
        },

    },
};
</script>

<style lang="scss">
.intTextarea {
    .ivu-form-item-error-tip {
        top: 75%;
    }
}

.no-label {
    .ivu-form-item-label:before {
        opacity: 0 !important;
    }
}
</style>
<style scoped lang="scss">

</style>
